import { Box, Button, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Filter from '../shared/Filter';
import OutfitsList from './OutfitsList';
import { collection, getDocs, query, where, doc, onSnapshot } from "firebase/firestore";
import { db } from '../../lib/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../lib/auth';
import BottomMenu from '../shared/BottomMenu';
import { useTranslation } from 'react-i18next';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import UserInfoForm from './UserInfoForm';

const OutfitsHome = () => {
  const [openFilter, setOpenFilter] = useState(false);
  const [outfits, setOutfits] = useState(null)
  const [user] = useAuthState(auth)
  const [pendingChange, setPendingChange] = useState(false)

  const [favoritesFilter, setFavoritesFilter] = useState(false);
  const [momentsFilter, setMomentsFilter] = useState([]);
  const [activeFilters, setActiveFilters] = useState("")
  const [userInfo, setUserInfo] = useState(null)


  const { t } = useTranslation();

  const clearFormFields = () => {
    setMomentsFilter([])
    setFavoritesFilter(false)
    setPendingChange(true)
    setActiveFilters("")
  }

  const manageActiveFilters = () => {
    if (momentsFilter.length !== 0 && favoritesFilter) {
      setActiveFilters(`${momentsFilter.name} / ${t('filterBy.favorite')}`)
    }
  }

  useEffect(() => {
    const outfitsCollectionRef = collection(db, 'users', user.uid, 'outfits');

    const constraints = []

    if (favoritesFilter) {
      constraints.push(where('favorite', '==', favoritesFilter))
      setActiveFilters(t('filterBy.favorite'))
    }

    if (momentsFilter.length !== 0) {
      constraints.push(where('moments', 'array-contains', momentsFilter.id))
      setActiveFilters(momentsFilter.name)
    }
    const outfitsQuery = query(outfitsCollectionRef, ...constraints);

    getDocs(outfitsQuery).then((querySnapshot) => {
      const documents = querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setOutfits(documents)
    }).catch((err) => {
      console.log("error getting document", err)
    })
    setPendingChange(false)
    manageActiveFilters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingChange])


  useEffect(() => {
    const userRef = doc(db, "users", user.uid);
    onSnapshot(userRef, (doc) => {
      setUserInfo(doc.data())
    });
  }, [user])

  if (userInfo == null) {
    return <CircularProgress />
  }

  if (userInfo.userName == null || userInfo.userName == "" || userInfo.phone == null || userInfo.phone == "" || userInfo.age == null || userInfo.age == "") {
    return (
      <UserInfoForm user={user} />
    )
  }

  return (
    <Box>
      {activeFilters &&
        <Box sx={{ marginTop: 1.5, marginBottom: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
          <Button onClick={clearFormFields} sx={{ position: 'absolute', left: 0 }}>
            <ArrowBackIosIcon />
          </Button>
          <Box sx={{ fontWeight: 'bold', fontSize: 16, textAlign: 'center' }}>{activeFilters}</Box>
        </Box>
      }
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <OutfitsList outfits={outfits} onPendingChange={setPendingChange} />
        <BottomMenu setOpenFilter={setOpenFilter} setFavorites={setFavoritesFilter} favoritesFilter={favoritesFilter} setPendingChange={setPendingChange} />
      </Box>
      <Filter setOpenFilter={setOpenFilter} openFilter={openFilter} setPendingChange={setPendingChange}
        moments={momentsFilter} setMoments={setMomentsFilter} setActiveFilters={setActiveFilters} />
    </Box>
  );
}

export default OutfitsHome;
